'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./icon-button.scss');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _withTooltip = require('../with-tooltip');

var _withTooltip2 = _interopRequireDefault(_withTooltip);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var iconSize = {
  small: '12',
  medium: '16',
  large: '18',
  'x-large': '18',
  'xx-large': '22'
};

function IconButton(_ref) {
  var color = _ref.color,
      disabled = _ref.disabled,
      size = _ref.size,
      shape = _ref.shape,
      className = _ref.className,
      icon = _ref.icon,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['color', 'disabled', 'size', 'shape', 'className', 'icon', 'onClick']);

  var classes = (0, _classnames2.default)('icon-button', color && 'icon-button--' + color, disabled && 'icon-button--disabled', size && 'icon-button--' + size, shape && 'icon-button--' + shape, className);

  return _react2.default.createElement(
    'span',
    _extends({
      className: classes,
      tabIndex: '0'
    }, props, {
      onClick: function onClick(e) {
        if (disabled) {
          e.preventDefault();
        } else if (typeof _onClick === 'function') {
          _onClick(e);
        }
      }
    }),
    icon && _react2.default.createElement(_icon2.default, { name: icon, size: iconSize[size], className: 'icon-button__icon' })
  );
}

IconButton.propTypes = {
  color: _propTypes2.default.oneOf(['neutral', 'primary', 'secondary', 'success', 'warning']),
  disabled: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large', 'xx-large']),
  shape: _propTypes2.default.oneOf(['circle', 'square']),
  icon: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

IconButton.defaultProps = {
  color: 'neutral',
  size: 'medium',
  shape: 'square'
};

exports.default = (0, _withTooltip2.default)(IconButton);